import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { DockTypeListComponent } from './dock-type-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [DockTypeListComponent],
  declarations: [DockTypeListComponent],
})
export class DockTypeListModule { }
